export default "__VITE_ASSET__DOldJfpW__"